export default {
  translateDayPart(dayPart, i18n) {
    const isInMorning = dayPart.includes('morning');
    const allDays = Object.keys(i18n.form.labels.daypartsoptions);
    // eslint-disable-next-line security-node/non-literal-reg-expr
    const day = dayPart.replace(new RegExp(`(${allDays.join('|')})`), '');

    let translation = i18n.form.labels.daysoptions[day];
    translation += isInMorning
      ? i18n.form.labels.daypartsoptions.morning
      : i18n.form.labels.daypartsoptions.afternoon;

    return translation;
  },
};
